$(document).ready(function () {
//   new fullpage('#fullpage', {
//     licenseKey: 'AD896CF7-EEB943CF-96C58C92-C7CCC0D0',
//     scrollOverflow: true,
//     anchors: ['Home', 'ChristianHormuth', 'MeineWeinberg', 'Galerie', 'Blog', 'Kontakt'],
//     // responsiveWidth: 1000,
//     bigSectionsDestination: 'top',
//     touchSensitivity: 10,
//     menu: '#myMenu',
//     afterSlideLoad: function () {
//       if ($('.nav a.active').hasClass('gold')) {
//         $('#myMenu').addClass('gold');
//         $('#myMenu').removeClass('grey');
//         $('.nav__mobtitle').addClass('gold');
//         $('.nav__mobtitle').removeClass('grey');

//       } else if
//         ($('#myMenu a.active').hasClass('grey')) {
//         $('#myMenu').addClass('grey');
//         $('#myMenu').removeClass('gold');
//         $('.nav__mobtitle').addClass('grey');
//         $('.nav__mobtitle').removeClass('gold');

//       } else {
//         $('#myMenu').removeClass('grey');
//         $('#myMenu').removeClass('gold');
//         $('.nav__mobtitle').removeClass('grey');
//         $('.nav__mobtitle').removeClass('gold');
//       }
//     },
//   });



  // replace slide arrows
  $('.fp-prev').replaceWith('<svg class="fp-controlArrow fp-prev" xmlns="http://www.w3.org/2000/svg" width="15.68" height="15.68" viewBox="0 0 15.68 15.68"><g id="Pfeil_links" data-name="Pfeil links" transform="translate(1.414 1.414)"><path id="Pfad_31" data-name="Pfad 31" d="M9.088,0V9.088H0" transform="translate(12.852 6.426) rotate(135)" fill="none" stroke="#ab907a" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></g></svg>');
  $('.fp-next').replaceWith('<svg class="fp-controlArrow fp-next" xmlns="http://www.w3.org/2000/svg" width="15.68" height="15.68" viewBox="0 0 15.68 15.68"><g id="Pfeil_links" data-name="Pfeil links" transform="translate(1.414 1.414)"><path id="Pfad_31" data-name="Pfad 31" d="M9.088,0V9.088H0" transform="translate(12.852 6.426) rotate(135)" fill="none" stroke="#ab907a" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></g></svg>');


  // exnter links in new tab
  $('a[rel*="external"]').click(function () {
    $(this).attr('target', '_blank');
  });



  // mobile menu
  $('.nav__mobtitle').click(function () {
    $('.nav>ul').fadeToggle();
    $(this).toggleClass('active');
    $('.nav__close').fadeToggle();
    if (!$('.nav__mobtitle').hasClass('active')) {
      fullpage_api.setAllowScrolling(true);
      fullpage_api.reBuild();
    } else {
      fullpage_api.setAllowScrolling(false);
    }
  });

  if ($(window).width() < 1200) {
    $('.nav ul a').click(function () {
      $('.nav>ul').fadeOut();
      $('.nav__mobtitle').removeClass('active');
      $('.nav .nav__sub').removeClass('open');
      $('.nav__close').fadeOut();
      fullpage_api.setAllowScrolling(true);
      fullpage_api.reBuild();
    });

    $('.nav__close').click(function () {
      $('.nav>ul').fadeOut();
      $('.nav .nav__sub').removeClass('open');
      $('.nav__mobtitle').removeClass('active');
      $(this).hide();
      fullpage_api.setAllowScrolling(true);
      fullpage_api.reBuild();
    });
    $('.nav__dropdown').click(function () {
      if ($(this).parent('li').find('ul').hasClass('open')) {
        $('.nav__sub ul').removeClass('open');
      } else {
        $('.nav__sub ul').removeClass('open');
        $(this).parent('li').find('ul').addClass('open');
      };
    });

    $('.slide__img').each(function () {
      $(this).parent('.slide__wrapper').find('.slide__quote').before(this);
    });
  }

  // blogslider
  $('.blog__items').slick({
    prevArrow: '<svg class="fp-controlArrow fp-prev" width="15.68" height="15.68" viewBox="0 0 15.68 15.68"><g id="Pfeil_links" data-name="Pfeil links" transform="translate(1.414 1.414)"><path id="Pfad_31" data-name="Pfad 31" d="M9.088,0V9.088H0" transform="translate(12.852 6.426) rotate(135)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></g></svg>',
    nextArrow: '<svg class="fp-controlArrow fp-next" width="15.68" height="15.68" viewBox="0 0 15.68 15.68"><g id="Pfeil_links" data-name="Pfeil links" transform="translate(1.414 1.414)"><path id="Pfad_31" data-name="Pfad 31" d="M9.088,0V9.088H0" transform="translate(12.852 6.426) rotate(135)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></g></svg>',
    infinite: false,
    slidesPerRow: 2,
    rows: 2,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesPerRow: 1,
          rows: 4,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesPerRow: 1,
          rows: 1,
        }
      },
    ]
  });


  // Galerie
  $('.galerie').slick({
    prevArrow: '<svg class="fp-controlArrow fp-prev" width="15.68" height="15.68" viewBox="0 0 15.68 15.68"><g id="Pfeil_links" data-name="Pfeil links" transform="translate(1.414 1.414)"><path id="Pfad_31" data-name="Pfad 31" d="M9.088,0V9.088H0" transform="translate(12.852 6.426) rotate(135)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></g></svg>',
    nextArrow: '<svg class="fp-controlArrow fp-next" width="15.68" height="15.68" viewBox="0 0 15.68 15.68"><g id="Pfeil_links" data-name="Pfeil links" transform="translate(1.414 1.414)"><path id="Pfad_31" data-name="Pfad 31" d="M9.088,0V9.088H0" transform="translate(12.852 6.426) rotate(135)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></g></svg>',
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });


  // * * * * * * * * * * * * * * * * * * * * * * * * *
  // * Link in a new window
  // *
  // *

  var $teaserText = $(".slide__contentInner");
  if ($teaserText.length) {
    $teaserText.readmore({
      speed: 1500,
      collapsedHeight: 500,
      moreLink: '<p class="--open"><a href="javascript:;" title="weiterlesen" class="teaser__readmore"><span>weiterlesen</span></a></p>',
      lessLink: '<p class="--close"><a href="javascript:;" title="weiterlesen" class="teaser__readmore"><span>schließen</span></a></p>'
    });
  }

});